import LinktreeServer from "../../server/linktree";
import OutputLinktreeEntry, {
  RequestLinktreeEntriesList,
  RequestLinktreeEntryById,
} from "../../dtos/linktree/entry";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class LinktreeServiceReader extends ServiceReader {
  constructor(protected api: LinktreeServer) {
    super();
  }

  public async list(count?: number): Promise<OutputLinktreeEntry[]> {
    const raw = await this.api.get(new RequestLinktreeEntriesList(count));
    if (!Array.isArray(raw))
      throw new TypeError("Linktree entry list is not an array.");

    return raw.map((value) => OutputLinktreeEntry.convert(value));
  }

  public async byId(id: string): Promise<OutputLinktreeEntry> {
    const raw = await this.api.get(new RequestLinktreeEntryById(id));

    return OutputLinktreeEntry.convert(raw);
  }
}

class LinktreeServiceCreator extends ServiceCreator {}
class LinktreeServiceUpdater extends ServiceUpdater {}
class LinktreeServiceDeleter extends ServiceDeleter {}

export default class LinktreeService extends Service {
  constructor() {
    super(new LinktreeServer());
  }

  public get read(): LinktreeServiceReader {
    return new LinktreeServiceReader(this.api as LinktreeServer);
  }
  public get create(): ServiceCreator {
    return new LinktreeServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new LinktreeServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new LinktreeServiceDeleter();
  }
}
